<!-- PAGE TITLE
        ================================================== -->
<section class="page-title-section bg-img cover-background top-position1 left-overlay-dark" data-overlay-dark="9"
         data-background="img/bg/bg-04.jpg"
         style="background-image: url(assets/img/bg/bg-04.jpg);">
    <div class="container">
        <div class="row text-center">
            <div class="col-md-12">
                <h1>Video Gallery</h1>
            </div>
            <div class="col-md-12">
                <ul>
                    <li><a routerLink="/">Home</a></li>
                    <li><a href="#!">Video Gallery</a></li>
                </ul>
            </div>
        </div>
    </div>
</section>


<section>
    <div class="container">
        <h2 class="text-center">Videos</h2>
        <div class="row">
            <div class="col-lg-6 col-md-6 col-sm-12 mt-5">
                <iframe class="cover-background w-100" style="height: 300px"
                        src="https://www.youtube.com/embed/Hw78_2JXVSg?si=vFaJ5X2hATg1IL5c"
                        title="YouTube video player" frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
            </div>

            <div class="col-lg-6 col-md-6 col-sm-12 mt-5">
                <iframe class="cover-background w-100" style="height: 300px"
                        src="https://www.youtube.com/embed/rIdmmEu_tQE?si=nrrO7IDbpisEJhQM"
                        title="YouTube video player" frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
            </div>

            <div class="col-lg-6 col-md-6 col-sm-12 mt-5">
                <iframe class="cover-background w-100" style="height: 300px"
                        src="https://www.youtube.com/embed/CxYLhz_3BnU?si=WWikkHbyqManIUUH"
                        title="YouTube video player" frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
            </div>

            <div class="col-lg-6 col-md-6 col-sm-12 mt-5">
                <iframe class="cover-background w-100" style="height: 300px"
                        src="https://www.youtube.com/embed/OWrX5j28whA?si=Y-Bm1vxp2xqLm29S"
                        title="YouTube video player" frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
            </div>

        </div>
    </div>
</section>
